import { useFlow } from "@rapid/contexts/FlowContext";
import { UseGuardStepHook } from "@rapid/hooks/useGuardStep";
import { BuildSteps } from "@rapid/types/flows";
import { useFlowState } from "../useFlowState";
import { useGuardBuildStep } from "./useGuardBuildStep";

export const useGuardBuildSteps: UseGuardStepHook = () => {
    const { task } = useFlow();
    const { step } = useFlowState();
    const guardBuildStep = useGuardBuildStep(step);

    const errors = [];

    if (!task) {
        errors.push("Task is required");
    }

    if (!step) {
        errors.push("Step is required");
    } else if (!Object.values(BuildSteps).includes(step as BuildSteps)) {
        errors.push(
            `Invalid build step - ${step}. Expected one of ${Object.values(BuildSteps).join(", ")}`
        );
    }

    guardBuildStep.errors = guardBuildStep.errors.concat(errors);

    return guardBuildStep;
};
